import React from 'react';
import EditHistoryTimeline from '../../core/public/EditHistoryTimeline';

const FIELD_I18N_KEYS = {
  name: 'products.history_field_name',
  description: 'products.history_field_description',
  status: 'products.history_field_status',
  type: 'products.history_field_type',
  'attribute.created': 'products.history_field_attribute_created',
  'attribute.deleted': 'products.history_field_attribute_deleted',
  'attribute_option.created': 'products.history_field_attribute_option_created',
  'attribute_option.deleted': 'products.history_field_attribute_option_deleted',
  variation_combinations: 'products.history_field_variation_combinations',
  'supply_purchase.added': 'products.history_field_supply_purchase_added',
  'supply_purchase.deleted': 'products.history_field_supply_purchase_deleted',
  'sku.created': 'products.history_field_sku_created',
  'sku.deleted': 'products.history_field_sku_deleted',
};

function resolveProductFieldLabel(fieldKey, translate) {
  const fk = String(fieldKey);
  const k = FIELD_I18N_KEYS[fk];
  if (k) return translate(k);
  if (fk.startsWith('sku.')) return `${translate('products.history_field_sku')}: ${fk}`;
  if (fk.startsWith('attribute.')) return `${translate('products.history_field_attribute')}: ${fk}`;
  return fk;
}

export default function ProductEditHistoryTimeline({ events = [], translate }) {
  return (
    <EditHistoryTimeline
      events={events}
      translate={translate}
      emptyMessageKey="products.edit_history_empty"
      entryMessageKey="products.edit_history_entry"
      resolveFieldLabel={resolveProductFieldLabel}
    />
  );
}
